import { useRequest } from 'ahooks'
import { Button, Form, Modal, Switch } from 'antd'
import { saveAs } from 'file-saver'
import { useAtom } from 'jotai'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { userInfoAtom } from '../user'

export const DevlopHomeExport = ({ selfIds }: { selfIds: string[] }) => {
  const { t } = useTranslation()
  const [viewer] = useAtom(userInfoAtom)
  const [visible, setVisible] = React.useState(false)
  const [form] = Form.useForm()

  const { data: devlopExportRoles } = useRequest('/api/devlop/export/roles')

  const { run: exportDevlop, loading: exportLoading } = useRequest(
    (data) => ({
      url: '/api/devlop/export/excel',
      method: 'POST',
      data,
      responseType: 'blob',
    }),
    {
      manual: true,
      onSuccess: (res) => {
        const date = moment().utcOffset(8).format('YYYYMMDD_HHmmss')
        saveAs(res, `devlop_${date}.xlsx`)
      },
    }
  )

  const roles = devlopExportRoles || []
  const canExport = viewer.isSuperAdmin || viewer.isMiniIPDCore || roles.includes(viewer.email)

  if (!canExport) {
    return null
  }

  return (
    <>
      <Button type='link' loading={exportLoading} onClick={() => setVisible(true)}>
        {t('export devlop')}
      </Button>
      <Modal
        title={t('export devlop')}
        visible={visible}
        onOk={() => {
          const fields = form.getFieldsValue()
          exportDevlop({ selfIds, fields })
          setVisible(false)
        }}
        onCancel={() => {
          setVisible(false)
        }}
        okButtonProps={{ loading: exportLoading }}
        cancelButtonProps={{ disabled: exportLoading }}
      >
        <Form
          form={form}
          initialValues={{
            selfId: true,
            name: true,
            email: true,
            startDate: true,
            endDate: true,
            priority: true,
            classification: true,
            status: true,
            actualWorkload: true,
            background: true,
            standard: true,
            goal: true,
            challenge: true,
          }}
        >
          <Form.Item name='selfId' label={t('index')} valuePropName='checked'>
            <Switch disabled />
          </Form.Item>
          <Form.Item name='email' label={t('devlop.owner')} valuePropName='checked'>
            <Switch disabled />
          </Form.Item>
          <Form.Item name='name' label={t('devlop.name')} valuePropName='checked'>
            <Switch />
          </Form.Item>
          <Form.Item name='startDate' label={t('devlop.detail.startDate')} valuePropName='checked'>
            <Switch />
          </Form.Item>
          <Form.Item name='endDate' label={t('devlop.detail.endDate')} valuePropName='checked'>
            <Switch />
          </Form.Item>
          <Form.Item name='classification' label={t('devlop.detail.classification')} valuePropName='checked'>
            <Switch />
          </Form.Item>
          <Form.Item name='actualWorkload' label={t('devlop.actualWorkload.title')} valuePropName='checked'>
            <Switch />
          </Form.Item>
          <Form.Item name='background' label={t('devlop.detail.background')} valuePropName='checked'>
            <Switch />
          </Form.Item>
          <Form.Item name='standard' label={t('devlop.detail.standard')} valuePropName='checked'>
            <Switch />
          </Form.Item>
          <Form.Item name='priority' label={t('devlop.detail.priority')} valuePropName='checked'>
            <Switch />
          </Form.Item>
          <Form.Item name='status' label={t('devlop.status.title')} valuePropName='checked'>
            <Switch />
          </Form.Item>
          <Form.Item name='goal' label={t('devlop.detail.goal')} valuePropName='checked'>
            <Switch />
          </Form.Item>
          <Form.Item name='challenge' label={t('devlop.detail.challenge')} valuePropName='checked'>
            <Switch />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
